// ProfileIcon.js
export function ProfileIcon({ className, width = 20, height = 20 }) {
    return (
        <svg 
            className={className}
            width={width}
            height={height}
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={{ verticalAlign: 'middle' }}
        >
            <path 
                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z" 
                stroke="currentColor" 
                strokeWidth="1.5"      // ← stroke-width → strokeWidth
                strokeLinecap="round"   // ← stroke-linecap → strokeLinecap
                strokeLinejoin="round"  // ← stroke-linejoin → strokeLinejoin
            />
            <path 
                d="M5 20V19C5 15.13 8.13 12 12 12C15.87 12 19 15.13 19 19V20" 
                stroke="currentColor" 
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function GraficitIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="20" x2="12" y2="10"/>
            <line x1="18" y1="20" x2="18" y2="4"/>
            <line x1="6" y1="20" x2="6" y2="16"/>
        </svg>
    );
}

export function MarketIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 11v2h4l5 4V7l-5 4H3z"/>
            <path d="M16 8l4-4v16l-4-4"/>
        </svg>
    );
}

export function InfoIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none">


        <rect x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
                stroke={color}
                stroke-width="1.8"/>

        
        <line x1="12"
                y1="10"
                x2="12"
                y2="15"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"/>

        <circle cx="12"
                cy="7.5"
                r="1.2"
                fill="currentColor"/>

        </svg>
    );
}

export function LucchettIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
    );
}

export function ImpostIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
    );
} 

export function DettaglIcon({ width = 24, height = 24, color = "currentColor"  }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">

        <rect x="3" y="4" width="18" height="16" rx="4"/>

        <path d="M7 9h10"/>
        <path d="M7 13h7"/>
        <path d="M7 17h5"/>

        </svg>
    );
} 

export function CookieIcon({ className, stroke = '#edf5e1', width = 24, height = 24 }) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke={stroke}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        width={width}
        height={height}
        >
        <path
            d="M12 2
            a10 10 0 1 0 10 10
            c-2.5.2-4.5-1.8-4.3-4.2
            .1-1.7-1.2-3-2.9-2.9
            C12.8 5.1 11 3.2 12 2z"
        />

        <circle cx="9" cy="10" r="1" />
        <circle cx="14.5" cy="8.5" r="1" />
        <circle cx="15" cy="14" r="1" />
        <circle cx="8.5" cy="15" r="1" />
        </svg>
    );
}

export function StemmaIcon({ width = 32, height = 32, color = "currentColor"  }) {
    return (
		<svg xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            stroke={color}
            strokeWidth="1"
            viewBox="0 0 24 24"
            fill="none">

            <path d="M12 3.5L6.5 6V11.2C6.5 15.3 9 18.7 12 20
                C15 18.7 17.5 15.3 17.5 11.2V6L12 3.5Z"
				stroke="currentColor"
				stroke-width="1"
				stroke-linejoin="round"/>
            {/* <!-- détail interne --> */}
            <path d="M9.5 12L11.2 13.7L14.8 10.2"
				stroke="currentColor"
				stroke-width="1"
				stroke-linecap="round"
				stroke-linejoin="round"/>
		</svg>
    );
}

export function LegalIcon({ width = 32, height = 32, color = "currentColor"  }) {
    return (
		<svg xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            stroke={color}
            //strokeWidth="1"
            viewBox="0 0 24 24"
            fill="none">

		    {/* <!-- axe --> */}
        <path d="M12 4V19"
				stroke="currentColor"
				stroke-width="1"
				stroke-linecap="round"/>

            {/* <!-- barre --> */}
            <path d="M6 7H18"
                    stroke="currentColor"
				stroke-width="1"
				stroke-linecap="round"/>

		    {/* <!-- plateaux --> */}
            <path d="M7.5 7L5.2 11H9.8L7.5 7Z"
				stroke="currentColor"
				stroke-width="1"
				stroke-linejoin="round"/>

            <path d="M16.5 7L14.2 11H18.8L16.5 7Z"
				stroke="currentColor"
				stroke-width="1"
				stroke-linejoin="round"/>

            {/* <!-- base --> */}
            <path d="M9.5 19H14.5"
				stroke="currentColor"
				stroke-width="1"
				stroke-linecap="round"/>
		</svg>
    );
}
